// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"fe411cee","730":"34f4a971","985":"cb8d1ee4"}[chunkId] + ".chunk.css";
};